<template>
    <b-overlay :show="busy" rounded="sm">
        <!-- {{ search }}<br /><br />
      {{ item }} -->
        <b-card class="standardpage reports invoices border-none">
            <!-- <b-card-header class="py-1 mb-2">
          <i :class="options.icon" class="text-primary mr-1"></i>
          {{ item.slac }}
          <span class="text-warning"
            >&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span
          >
        </b-card-header> -->
            <div class="availtable datatable text-left">
                <b-card-body class="py-0">
                    <b-tabs class="gridtabs">
                        <b-tab :active="true">
                            <template #title>
                                <div class="badgecontainer pr-5">
                                    <i :class="options.icon" class="text-primary mr-1"></i>
                                    <span class="text-center badgenormal badge-secondary badge-pill">
                                        {{ item.traveller }}
                                    </span>
                                    <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit"
                                    }}&gt;</span>
                                </div>
                            </template>
                            <p class="py-3 px-0">
                                <b-row>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" :label="$helpers.requiredlabel(
                                            requirement_travellerprofile,
                                            'Client SL A/C'
                                        )
                                            " :class="$helpers
                                                .requiredlabel(
                                                    requirement_travellerprofile,
                                                    'Client SL A/C'
                                                )
                                                .slice(0, 1) == '*'
                                                ? 'text-danger'
                                                : ''
                                                " label-size="sm">
                                            <treeselect placeholder="Select slac..."
                                                searchPromptText="Type at least 3 chars..." v-model="item.slac"
                                                :clearable="true" :async="true" :load-options="treeselect_loadSLAC"
                                                :show-count="true" :flatten-search-results="true"
                                                :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                                :disabled="false" :multiple="true">
                                                <div slot="value-label" slot-scope="{ node }">
                                                    {{ node.raw.id }}
                                                </div>
                                            </treeselect>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" :label="$helpers.requiredlabel(
                                            requirement_travellerprofile,
                                            'Traveller'
                                        )
                                            " :class="$helpers
                                                .requiredlabel(
                                                    requirement_travellerprofile,
                                                    'Traveller'
                                                )
                                                .slice(0, 1) == '*'
                                                ? 'text-danger'
                                                : ''
                                                " label-size="sm">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.traveller"
                                                    placeholder="Enter traveller" size="sm" trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.traveller = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="DOB" label-for="dob" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.dob" placeholder="Enter DOB"
                                                    size="sm" trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.dob = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="EmployeeNo" label-for="employeeno" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.employeeno"
                                                    placeholder="Enter employeeno" size="sm" trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.employeeno = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                     <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Email" label-for="email" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.email" placeholder="Enter email"
                                                    size="sm" trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.email = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Mobile" label-for="mobile" label-cols="12">
                                            <b-input-group>
                                                <b-input-group class="treeselect_all" style="left:35px; top:-13px">
                                                    <i id="mobile" class="fa fa-info-circle text-black"></i>
                                                </b-input-group>
                                                <b-tooltip target="mobile" triggers="hover" placement="top">
                                                    When empty the EmployeeNo will be used in the feed.
                                                </b-tooltip>


                                                <b-form-input type="text" v-model="item.mobile"
                                                    placeholder="Enter mobile" size="sm" trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.mobile = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                       <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Country Code (ISO)" label-for="iso_country" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.iso_country"
                                                    placeholder="Enter country code" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.iso_country = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Feed" label-for="feed" label-cols="12">
                                            <treeselect instanceId="feed" type="number" v-model="item.feed"
                                                :clearable="false" :options="feed_options"></treeselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </p>
                        </b-tab>
                        <b-tab>
                            <template #title>
                                <i class="fa fa-comments-o text-primary mr-1"></i>
                                Notes</template>
                            <p class="py-3 px-0">
                                <b-row>
                                    <b-col cols="12">
                                        <b-form-group label="Notes" label-for="notes" label-cols="12">
                                            <b-form-textarea id="data" v-model="item.notes" placeholder="Enter notes"
                                                rows="6" class="smalltextarea"></b-form-textarea>
                                        </b-form-group> </b-col></b-row>

                            </p>
                        </b-tab>
                        <b-tab v-if="idselected">
                            <template #title>
                                <i class="fa fa-history text-primary mr-1"></i> Audit
                            </template>
                            <p class="py-3 px-0">
                                <b-row>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Created At" label-for="created_at" label-cols="12">
                                            <b-input-group>
                                                <b-input-group-prepend>
                                                    <b-form-datepicker size="sm" v-model="item.created_at" button-only
                                                        label-help="" locale="en-GB"
                                                        :disabled="true"></b-form-datepicker>
                                                </b-input-group-prepend>
                                                <b-form-input size="sm" id="date" v-model="item.created_at" type="text"
                                                    placeholder="YYYY-MM-DD" autocomplete="off"
                                                    :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.created_at = null" :disabled="true">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Created By" label-for="created_by" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.created_by" placeholder=""
                                                    size="sm" :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.created_by = ''" :disabled="true">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                                            <b-input-group>
                                                <b-input-group-prepend>
                                                    <b-form-datepicker size="sm" v-model="item.updated_at" button-only
                                                        label-help="" locale="en-GB"
                                                        :disabled="true"></b-form-datepicker>
                                                </b-input-group-prepend>
                                                <b-form-input size="sm" id="date" v-model="item.updated_at" type="text"
                                                    placeholder="YYYY-MM-DD" autocomplete="off"
                                                    :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.updated_at = null" :disabled="true">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.updated_by" placeholder=""
                                                    size="sm" :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.updated_by = ''" :disabled="true">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </p>
                        </b-tab></b-tabs>
                </b-card-body>
                <b-card-footer class="nopadding mt-2">
                    <b-row no-gutters>
                        <b-col cols="auto" class="text-left mr-3">
                            <b-button squared size="sm" variant="primary" @click="saveit"
                                v-if="user.permissions.includes('setup_travellerprofiles.admin')">
                                <i class="fa fa-check"></i>
                                Save It
                            </b-button>
                        </b-col>
                        <b-col class="text-left my-auto">
                            <div v-if="busy">
                                <i class="fa fa-spinner fa-spin text-primary"></i>
                            </div>
                            <div v-else>
                                <span v-html="message"></span>
                            </div>
                        </b-col>
                        <b-col class="text-right" cols="8">
                            <b-button squared size="sm" variant="secondary" class="mr-1" @click="discard">
                                <i class="fa fa-chevron-left pr-1"></i>
                                Back
                            </b-button>
                        </b-col>
                    </b-row>
                </b-card-footer>

            </div>
        </b-card>
    </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

import moment from "moment";

export default {
    name: "TravellerProfileEdit",
    data() {
        return {
            busy: false,
            requirement_travellerprofile: {
                slac: "Client SL A/C",
                traveller: "Traveller"
            },
            item: {
                id: null,
                slac: [],
                feed: "ANVIL",
                traveller: null,
                dob: null,
                employeeno: null,
                email: null,
                mobile: null,
                iso_country: null,
                notes: null,
            },
            feed_options: [
                { id: "ANVIL", label: "ANVIL" },
                { id: "ISOS", label: "ISOS" },
            ],
            options: {
                title: "Traveller Profile",
                icon: "fa fa-list",
            },
        };
    },
    watch: {
        selection() {
            this.load();
        },
    },
    methods: {
        async load() {
            let variables = {
                id: this.selection[0].id,
                dateformat: "YYYY-MM-DD",
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
              query setup_travellerprofiles($id: String) {
                setup_travellerprofiles(id: $id) {
                  id
                  slac
                  feed
                  traveller
                  dob
                  employeeno
                  email
                  mobile
                  iso_country
                  notes
                  created_at
                  created_by
                  updated_at
                  updated_by
                }
              }
            `,
                    variables,
                });

                if (response.data.setup_travellerprofiles.length > 0) {
                    this.item = response.data.setup_travellerprofiles[0];
                    this.item.slac = this.item.slac ? this.item.slac.split(",") : [];

                }
            } catch (error) {
                console.log(error);
            }
            this.busy = false;
        },
        async saveit() {
            let requirement = { ...this.requirement_travellerprofile };

            console.log(requirement);

            let requirements = "";
            for (var prop in requirement) {
                if (this.item[prop] == null) {
                    requirements += requirement[prop] + ", ";
                    // break;
                }
            }
            if (requirements.length > 0) {
                this.message =
                    "<span class='text-danger'>" +
                    requirements.slice(0, -1) +
                    " required field(s). </span>";
                return;
            }
            this.busy = true;

            let variables = { rows: [this.cleanit(this.item)] };
            if (variables.rows[0].slac) {
                variables.rows[0].slac = this.item.slac.join(",")
            }

            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
              mutation setup_travellerprofiles_save(
                $rows: [setup_travellerprofiles_input]
                $dateformat: String
              ) {
                setup_travellerprofiles_save(rows: $rows, dateformat: $dateformat) {
                  id
                  slac
                  feed
                  traveller
                  dob
                  employeeno
                  email
                  mobile
                  iso_country
                  notes               
                }
              }
            `,
                    variables,
                });
                console.log(response);
                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false;
        },

        required(e) {

            this.requirement = {
                slac: "Client SL A/C",
                traveller: "Traveller"
            };
        },
    },
};
</script>

<style></style>